import { signal } from '../../services/SignalsService'
import { delay } from '../../utils/Delay'

const name = 'BUILD-STAGE'

async function execute() {
  delay(2).then(() => {
    signal.dispatch('LOGO-ANIM:DONE')
  })
  return signal.promise('LOGO-ANIM:DONE')
}

export function getLogoShowAction() {
  return {
    name,
    execute,
  }
}
